import { render, staticRenderFns } from "./InformHandlePolicyPop.vue?vue&type=template&id=86765b2a"
import script from "./InformHandlePolicyPop.vue?vue&type=script&lang=js"
export * from "./InformHandlePolicyPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86765b2a')) {
      api.createRecord('86765b2a', component.options)
    } else {
      api.reload('86765b2a', component.options)
    }
    module.hot.accept("./InformHandlePolicyPop.vue?vue&type=template&id=86765b2a", function () {
      api.rerender('86765b2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/popup/InformHandlePolicyPop.vue"
export default component.exports